import { defineComponent } from 'vue';
import { QInput, QIcon } from 'quasar';
import utils from '../../../Shared/utils.jsx';
import BaseComponentMixin from './BaseComponentMixin.jsx';

const SEARCH_SEARCH_CODE_BEHIND = {
    actionsKey: 'SearchActions',
    handlerSuffix: '_Search',
    actionTypeSchema: '/schema/public/Platform.Schema.UIActions.v1/UIAction_Script',
    buildScopeMethodTemplate(methodName) {
        return `\t${methodName}(context) {\n\t\t// Place your search handler here\n\t}`;
    },
};

export default defineComponent({
    name: 'search-dsgn',
    mixins: [BaseComponentMixin],
    components: { QInput, QIcon },
    computed: {
        containerStyle() {
            return {
                ...utils.getSize(this.controlData?.SizeOptions, this.parentType, this.$parent),
                ...utils.getStyleHints(this.controlData?.StyleHints, this),
            };
        },
        label() {
            return this.controlData?.Title || 'Search';
        },
    },
    methods: {
        handleDesignerDblClick(e) {
            e.stopPropagation();
            e.preventDefault();
            this.Root?.openCodeBehind?.(this, SEARCH_SEARCH_CODE_BEHIND);
        },
    },
    render() {
        if (!this.controlData)
            return null;

        return (
            <div
                class={{ 'c-Search': true, 'designer-container': true, selected: this.selected$, 'q-ma-sm': true }}
                style={this.containerStyle}
                onClick={(e) => this.handleClick(e)}
                onDblclick={(e) => this.handleDesignerDblClick(e)}>
                <div class={{ 'designer-container-hovering': true, 'designer-container-selected': this.selected$ }} />
                <QInput
                    outlined
                    dense
                    readonly
                    label={this.label}
                    modelValue=""
                >
                    {{
                        append: () => <QIcon name="mdi-magnify" />,
                    }}
                </QInput>
            </div>
        );
    },
});
